import React, {useEffect} from "react"
import {layoutSidebarLeftWidth} from "../settings"
import {iconCopy, iconMirrorHorizontal, iconMirrorVertical, iconRemove, iconRotateMinus, iconRotatePlus, iconSettings} from "../Helper/Icons"
import {useHelp, useRoomParameters, useRoomSetup, useLocal} from "../AppContext"
import {useSidebar} from "../Hooks/Sidebar"
import {AddItem} from "../Components/Menu/AddItem"
import {CtaBubble, CtaBubbleLabel} from "../Components/CtaBubble"
import {MenuLeft} from "../Components/MenuLeft"
import {PropertiesSize} from "../Components/SideBar/PropertiesSize"
import {SelectItem} from "../Components/Menu/SelectItem"
import {SideBarRightBody, SideBarRightHead, SideBarRightHeadItem, SideBarRightLayout} from "../Components/SideBar/SideBarRight"
import {SideBarRightHandel} from "../Components/SideBar/SideBarRightHandel"
import {SortNote} from "../Components/Menu/SortNote"
import {interiorSort} from "../Helper/InteriorSort"
import style from "./Ceiling.css"

export const Ceiling = () => {
    const help = useHelp()
    const roomSetup = useRoomSetup()
    const sidebar = useSidebar(true, true)
    const local = useLocal()

    useEffect(() => {
        roomSetup.unsetHandle()
        help.setContext('deckenleuchten')
    }, [])

    return <>
        <MenuLeft label={local.__("Decken & Leuchten")}>
            <CtaText/>
            <CeilingUsable/>
            <Items sidebar={sidebar}/>
            <Note/>
        </MenuLeft>
        <Properties sidebar={sidebar}/>
        <CtaBubble name={"ceiling"} left={layoutSidebarLeftWidth + 40} top={155}>
            <CtaBubbleLabel>
                {local.__("Decken & Leuchten")}
            </CtaBubbleLabel>
            <div dangerouslySetInnerHTML={{__html: local.__("Bitte wählen sie ihre Deckenelemente")}}/>
        </CtaBubble>
    </>
}

const CtaText = () => {
    const local = useLocal()
    return <div className={style.ctaText}>{local.__("Erklärungtext zur Decken & Leuchten")}</div>
}

const CeilingUsable = () => {
    const local = useLocal()
    const roomSetup = useRoomSetup()

    const onClick = () => {
        roomSetup.toggleCeilingUsable()
    }

    return <SelectItem isActive={roomSetup.isCeilingUsable()} onClick={onClick}>
        <div>{local.__("Bietet Ihre Decke Platz für Akustikelemente?")}</div>
    </SelectItem>
}

const Items = ({sidebar}) => {
    const local = useLocal()
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()

    const interiorItems = interiorSort(local, [
        ...roomParameters.getInteriors("lamp", roomSetup.getType()),
    ])

    if (!roomSetup.isCeilingUsable()) {
        return null;
    }

    const add = (item) => {
        roomSetup.addInterior(item)
        sidebar.open()
    }

    return interiorItems.map((item) => <AddItem key={item.id} onClick={() => add(item)}>
        <div className={style.item}>
            <div style={{backgroundImage: `url("${item.previewThumbnail}")`}}/>
            <div>
                {local.getLabel(item.name)}
            </div>
        </div>
    </AddItem>)
}


const Note = () => {
    const roomSetup = useRoomSetup()

    if (!roomSetup.isCeilingUsable()) {
        return null;
    }

    return <SortNote/>
}

const Properties = ({sidebar}) => {
    const local = useLocal()
    const roomSetup = useRoomSetup()
    const label = local.getLabel(roomSetup.itemGetProperty("name"))

    const open = () => {
        sidebar.open()
    }

    const rotateClockwise = () => {
        roomSetup.itemRotateClockwise()
    }
    const rotateAnticlockwise = () => {
        roomSetup.itemRotateAnticlockwise()
    }

    const mirrorVertical = () => {
        roomSetup.itemMirrorVertical()
    }
    const mirrorHorizontal = () => {
        roomSetup.itemMirrorHorizontal()
    }

    const copy = () => {
        roomSetup.itemCopy()
    }

    const remove = () => {
        roomSetup.itemRemove()
    }

    useEffect(() => {
        if (!roomSetup.getHandle()) sidebar.disable()
        else sidebar.enable()
    }, roomSetup.getHandle())

    return <SideBarRightHandel sidebar={sidebar}>
        <SideBarRightLayout>
            <SideBarRightHead>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} isActive={sidebar.isOpen()} icon={iconSettings} label={label} onClick={open}/>
                <SideBarRightHeadItem isDisabled={!roomSetup.itemAllowUserInput('rotate')} icon={iconRotatePlus} label={local.__("45° nach rechts drehen")} onClick={rotateClockwise}/>
                <SideBarRightHeadItem isDisabled={!roomSetup.itemAllowUserInput('rotate')} icon={iconRotateMinus} label={local.__("45° nach links drehen")} onClick={rotateAnticlockwise}/>
                <SideBarRightHeadItem isDisabled={!roomSetup.itemAllowUserInput('mirror')} icon={iconMirrorVertical} label={local.__("vertikal spiegeln")} onClick={mirrorVertical}/>
                <SideBarRightHeadItem isDisabled={!roomSetup.itemAllowUserInput('mirror')} icon={iconMirrorHorizontal} label={local.__("horizotal spiegeln")} onClick={mirrorHorizontal}/>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} icon={iconCopy} label={local.__("duplizieren")} onClick={copy}/>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} icon={iconRemove} label={local.__("entfernen")} onClick={remove}/>
            </SideBarRightHead>
            <SideBarRightBody isOpen={sidebar.isOpen()}>
                <PropertiesSize/>
            </SideBarRightBody>
        </SideBarRightLayout>
    </SideBarRightHandel>
}
